export enum CounterpartyEndPoint {
  GetList = 'clients/get/',
  GetInternal = 'clients/int/get/',
  GetCount = 'my/clients/count/',
  GetOptions = 'client/check/',
  GetTypes = 'client/types/tbl/get/',
  GetManagerId = 'client/manager/id/get/',
  Add = 'client/add/',
  Edit = 'client/edit/',
  FnsLegalEntityGet = 'external/fns/legalentity/get/',
}

export enum LegalFormEndPoint {
  GetList = 'legal/forms/tbl/get/',
}

export enum SegmentEndPoint {
  GetList = 'segments/tbl/get/',
  Add = 'segments/add/',
  Edit = 'segments/edit/',
  Delete = 'segments/del/',
}

export enum RegionEndPoint {
  GetList = 'regions/get/',
  Add = 'regions/add/',
  Edit = 'regions/edit/',
  Delete = 'regions/del/',
}

export enum CategoryEndPoint {
  GetList = 'categories/tbl/get/',
}

export enum ManagerEndPoint {
  GetList = 'managers/get/',
}

export enum CityEndPoint {
  GetList = 'city/get/',
}

export enum TimezoneEndPoint {
  GetList = 'timezones/get/',
}
